import _ from 'underscore';
import type React from 'react';
import { withGlobalErrorView } from './with-global-error-view';

export const fallbackOnChunkError = ({
  name,
}: {
  name?: string;
} = {}) => {
  if (name !== 'ChunkLoadError') {
    return;
  }
  if (window.triggerFallbackResource) {
    window.triggerFallbackResource();
  }
};

export const withChunkErrorActionGlobalErrorView = _.partial(withGlobalErrorView, _, _, _, fallbackOnChunkError) as <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  errorOptions?: Parameters<typeof withGlobalErrorView>[1],
  componentName?: string
) => React.ComponentType<P>;
